import { getGetApiWorkspaceUserGetRoleQueryKey, useGetApiWorkspaceUserGetRole, WorkspaceUserRole } from "@/API";

export function UseWorkspaceAuth(workspaceId: string, role: WorkspaceUserRole) {
    const _role = useGetApiWorkspaceUserGetRole({ workspaceId: workspaceId }, {
        query: {
            enabled: !!workspaceId,
            queryKey: getGetApiWorkspaceUserGetRoleQueryKey({ workspaceId: workspaceId })
        }
    })
    if (!workspaceId) return false
    if (role == "None") return false
    if (!_role.data?.data) return false
    if (role == "Viewer") return ["Owner", "Manager", "Editor", "Viewer"].includes(_role.data?.data)
    if (role == "Editor") return ["Owner", "Manager", "Editor"].includes(_role.data?.data)
    if (role == "Manager") return ["Owner", "Manager"].includes(_role.data?.data)
    if (role == "Owner") return ["Owner"].includes(_role.data?.data)
    return false
}